<template>
<div>
  <!-- <div v-for="contact in contacts" v-bind:key="contact.id">
    <ListPanelItem :contact='contact' style="margin-bottom: 1em;"/>
  </div> -->


<!-- {{localAllActivities}} -->

<div v-for="activity in localAllActivities" v-bind:key="activity.id">
    <ListPanelItem :activity='activity' style="margin-bottom: 1em;"/>
  </div>

</div>
</template>


<script>
import ListPanelItem from '@/components/main/activity/ListPanelItem.vue';
import {mapGetters, mapActions } from 'vuex'; 

export default {
  

  name: 'ListPanelOpen',
  components: {
    ListPanelItem
  },
  props: {
    // msg: String,
  },
  data() {
    return  {
      localAllActivities: [],
      isOpen: false
    }
  },
  created () {
    // this.fetchActivities()
    this.localAllActivities = JSON.parse(JSON.stringify(this.allActivities))
    // this.localAllActivities = this.sortLocally()
    this.localAllActivities = this.filterLocally()
    this.sortLocally()
  },
  computed: {
    ...mapGetters(['getProfile', 'allActivities']), //'selectedContact'
  },
  methods: {
    ...mapActions(['updateActivity','putSelectedActivity']), //'addNewContact', 'addNewActivity', 'fetchActivities',
   
    onToggleOpen () {
      this.isOpen = !this.isOpen
    },
    filterLocally() {
      console.log("filterLocally ")
        var tmp = this.localAllActivities.filter(function (activity) {
        var date1 = new Date(activity.due.date);
        var today = new Date();
        // console.log(date1 >= today)
        return (date1 >= today);
      });
      return tmp
    },
    sortLocally() {
      console.log("sortLocally ")
      this.localAllActivities.sort(function(a,b){ return new Date(a.due.date) - new Date(b.due.date) })
    },
  },
  watch: {
    allActivities (newVal) {
      this.localAllActivities = JSON.parse(JSON.stringify(newVal))
      this.localAllActivities = this.filterLocally()
      // this.localAllActivities = this.sortLocally()
      // this.filterLocally()
      this.sortLocally()
      console.log("watch -> allActivities @ ListPanel.vue triggered")
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>